/**
 * Starter SHACL rule table — consumer-owned rules injected into the
 * Repository's `ShaclRuleRegistry`.
 *
 * Starter imports the same generated 320-rule set as Studio (compiled from
 * `cogo-ns-v1.ttl` via `@cogo/kg-repository`'s `compile-shacl` script —
 * Phase 2 §5.1 #6). Starter-specific rules can be appended below.
 *
 * Regenerate upstream:
 *   pnpm --filter @cogo/kg-repository compile-shacl
 */

import type { ShaclQueryRule } from '@cogo/kg-browser'
import {
  COGO_NS_V1_STRUCTURAL_RULES,
  type ValidationPhase,
} from '@cogo/kg-repository'

/** Structural-phase rules — generated from `cogo-ns-v1.ttl`. */
const STRUCTURAL_RULES: readonly ShaclQueryRule[] = COGO_NS_V1_STRUCTURAL_RULES

/** Binding-phase rules — post-bindExample. */
const BINDING_RULES: readonly ShaclQueryRule[] = []

/** Phase → rule table injected into `MapBackedRuleRegistry` at provider mount. */
export const STARTER_SHACL_RULES: Record<ValidationPhase, readonly ShaclQueryRule[]> = {
  structural: STRUCTURAL_RULES,
  binding: BINDING_RULES,
}
